import type { IconData } from '@stacksjs/iconify-core'

export const cu4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGqHqQoeFk\"><path fill-opacity=\".7\" d=\"M-32 0h682.7v512H-32z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGqHqQoeFk)\" transform=\"translate(30)scale(.94)\"><path fill=\"#002a8f\" d=\"M-32 0h768v512H-32z\"/><path fill=\"#fff\" d=\"M-32 102.4h768v102.4H-32zm0 204.8h768v102.4H-32z\"/><path fill=\"#cb1515\" d=\"m-32 0l440.7 255.7L-32 511z\"/><path fill=\"#fff\" d=\"M161.8 325.5L114.3 290l-47.2 35.8l17.6-58.1l-47.2-36l58.3-.4l18.1-58l18.5 57.8l58.3.1l-46.9 36.3z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cu4x3
